<form [formGroup]="dataForm" class="without-default-focus">
    <div class="form-item form-item-help">
        <mat-form-field class="with-info-icon">
            <mat-label>Date de référence</mat-label>
            <mat-select formControlName="dateReference" required tabindex="10">
                @for (item of DateReferencesList; track item) {
                    <mat-option [value]="item.value">
                        {{ item.name }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>
        <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="Définit la date du dossier à utiliser pour la création du rappel" matTooltipPosition="right"></fa-icon>
    </div>

    <!-- Si la dta e de référence sélectionnée est un attribut de type date -->
    @if (dataForm.get('dateReference').value === DateReferences.DateAttribute) {
        <div class="form-item">
            @if (attributesTypeDate.length === 0) {
                <mat-error>Aucun attribut de type date</mat-error>
            } @else {
                <mat-form-field class="with-info-icon">
                    <mat-label>Attribut de type date</mat-label>
                    <mat-select formControlName="attributeId">
                        @for (attribute of attributesTypeDate; track attribute.id) {
                            <mat-option [value]="attribute.id">
                                {{ attribute.name }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            }
        </div>
    }

    <div class="form-item">
        <mat-form-field class="mat-form-field-frequency">
            <mat-label>Délai avant déclenchement</mat-label>
            <input matInput type="text" formControlName="delayBeforeTriggering" autocomplete="off" (focusout)="onDurationChange('delayBeforeTriggering')" />
            @if (dataForm.get('delayBeforeTriggering').hasError('pattern') && (dataForm.get('delayBeforeTriggering')?.dirty || dataForm.get('delayBeforeTriggering')?.touched)) {
                <mat-error>Le délai avant déclenchement est incorrect</mat-error>
            }
        </mat-form-field>
    </div>

    <div class="form-item">
        <mat-checkbox class="accent-button" formControlName="isRepeated">Répéter le rappel</mat-checkbox>
    </div>

    <div class="form-item">
        <mat-form-field class="mat-form-field-frequency">
            <mat-label>Intervalle entre les répétitions</mat-label>
            <input matInput type="text" formControlName="frequencyFormControl" autocomplete="off" (focusout)="onDurationChange('frequencyFormControl')" />
            @if (dataForm.get('frequencyFormControl').hasError('required') && (dataForm.get('frequencyFormControl')?.dirty || dataForm.get('frequencyFormControl')?.touched)) {
                <mat-error>L'intervalle entre les répétitions est obligatoire</mat-error>
            }
            @if (dataForm.get('frequencyFormControl').hasError('pattern') && (dataForm.get('frequencyFormControl')?.dirty || dataForm.get('frequencyFormControl')?.touched)) {
                <mat-error>L'intervalle entre les répétitions est incorrect</mat-error>
            }
        </mat-form-field>
    </div>

    <div class="form-item">
        <mat-form-field class="mat-form-field-max-occurences">
            <mat-label>Nombre de répétitions</mat-label>
            <input matInput type="text" formControlName="maxOccurencesFormControl" autocomplete="off" />
            @if (
                dataForm.get('maxOccurencesFormControl')?.errors?.pattern && (dataForm.get('maxOccurencesFormControl')?.dirty || dataForm.get('maxOccurencesFormControl').touched)
            ) {
                <mat-error>Le champ doit être un entier.</mat-error>
            }
        </mat-form-field>
    </div>

    <div class="form-item">
        <mat-form-field class="mat-form-field-action-type">
            <mat-label>Type de rappel</mat-label>
            <mat-select formControlName="reminderActionTypeFormControl">
                <mat-option [value]="ReminderActionType.DisplayNotification">Affichage d'une notification</mat-option>
                <mat-option [value]="ReminderActionType.SendMail">Envoi d'un mail</mat-option>
            </mat-select>
            @if (
                dataForm.get('reminderActionTypeFormControl')?.errors?.required &&
                (dataForm.get('reminderActionTypeFormControl')?.dirty || dataForm.get('reminderActionTypeFormControl').touched)
            ) {
                <mat-error>Le champ 'Type de rappel' est obligatoire.</mat-error>
            }
        </mat-form-field>
    </div>

    @if (dataForm.get('reminderActionTypeFormControl')?.value) {
        @if (dataForm.get('reminderActionTypeFormControl')?.value === ReminderActionType.SendMail) {
            <div class="form-item">
                <mat-form-field>
                    <mat-label>Modèle de mail</mat-label>
                    <mat-select formControlName="emailTemplate" required tabindex="10">
                        @for (template of emailTemplates; track template.id) {
                            <mat-option [value]="template.id">
                                {{ template.name }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        } @else {
            <div class="form-item">
                <mat-form-field class="mat-form-field-frequency">
                    <mat-label>Titre</mat-label>
                    <input matInput type="text" formControlName="notificationTitle" autocomplete="off" />
                </mat-form-field>
            </div>

            <div class="form-item">
                <mat-form-field class="mat-form-field-frequency">
                    <mat-label>Texte</mat-label>
                    <input matInput type="text" formControlName="notificationText" autocomplete="off" />
                </mat-form-field>
            </div>
        }
    }
</form>
